export default "__VITE_ASSET__CMMlJ8GQ__"